import React from 'react'
import { i18n } from '@fs/zion-locale'

const AboutPage = React.lazy(() => import('./pages/AboutPage/AboutPage'))
const LoadingSpinner = React.lazy(() => import('./shared/components/LoadingSpinner'))

export default function AboutPageRoutes() {
  if (i18n.language.startsWith('zh')) {
    window.location.replace(`https://www.familysearch.org/chinese/surnames/about`)
    return <LoadingSpinner />
  }
  return <AboutPage />
}
